/**
 * Compare Homes chrome strings (#1713).
 *
 * English only, on purpose: the operator-editable label is `compare.buttonText`
 * (the toggle, the pick chip and the Compare button). Everything else is chrome
 * the ckit tool also shipped as English defaults. Adding these to the explorer
 * translations table means a schema key, an editor row and a shipped-locale
 * entry per string; that is a follow-up, disclosed in the PR body.
 */
export const COMPARE_LABELS = {
  title: 'Compare homes',
  clear: 'Clear',
  close: 'Close',
  added: 'Added',
  differences: 'Show only differences',
  copyLink: 'Copy link',
  linkCopied: 'Link copied.',
  share: 'Share',
  allSame: 'These homes match on every detail listed here.',
  included: 'Included',
  notListed: 'Not listed',
  price: 'Price',
  priceDates: 'Total for your dates',
  sleeps: 'Sleeps',
  bedrooms: 'Bedrooms',
  bathrooms: 'Bathrooms',
  location: 'Location',
  amenities: 'Amenities',
  view: 'View home',
  oneMore: 'Pick 1 more to compare',
  studio: 'Studio',
  /** "From $280 / night" */
  priceFrom: (amount: string) => `From ${amount} / night`,
  /** "Tap "+ Compare" on up to 3 homes" */
  modeHint: (button: string, max: number) => `Tap “+ ${button}” on up to ${max} homes`,
  ofMax: (count: number, max: number) => `${count} of ${max} selected`,
  maxReached: (max: number) => `You can compare up to ${max} homes.`,
  removeHome: (title: string) => `Remove ${title}`,
  pickAria: (button: string, title: string) => `${button} ${title}`,
  copyFailed: (url: string) => `Copy this link: ${url}`,
  /** One or more linked homes the loaded results do not hold. */
  missing: (count: number) => (count === 1
    ? '1 linked home is not in these results.'
    : `${count} linked homes are not in these results.`),
} as const
